import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { CommonApiData } from "../../EnvConfig/env_config";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { FindTranslatedKey } from "../CommonComponents/CustomHooks";
import { BulkClearData, DownloadFileAtURL, ERRORDATALIST, HandleBulkInsertData, readFile2 } from "../CommonComponents/ExportData";
import { ImportButton } from "../CommonComponents/InputBox";
const ImportPickUpRequest = ({ menuText }) => {
    const [ImportData, setImportData] = useState({ sheet1: [], sheet2: [], sheet3: [] });

    const [Status, setStatus] = useState([]);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const PageType = searchParams.get('PageType');
    const [Name, setName] = useState('');
    const dispatch = useDispatch();
    const ErrorData = async () => {
        await ERRORDATALIST(Status, 'PickUpRequest')
    };
    const validateHeaders = (sheet1, sheet2, sheet3) => {
        const requiredHeaders1 = ["AutoAwbNo", "CustReferenceNo", "ReferenceNumber", "ShipmentDate", "CCode", "ConsignorName", "ConsignorEmailID", "ConsignorPhoneNo", "ConsignorCountryCode", "ConsignorStateCode", "ConsignorCityCode", "ConsignorZipCode", "ConsignorAddress1", "ConsignorAddress2", "ConsignorAddress3", "ConsignorGSTIN", "ConsigneeName", "ConsigneeEmailID", "ConsigneePhoneNo", "ConsigneeCountryCode", "ConsigneeStateCode", "ConsigneeCityCode", "ConsigneeZipCode", "ConsigneeAddress1", "ConsigneeAddress2", "ConsigneeAddress3", "ConsigneeGSTIN", "TotalPacket", "TotalValue", "CurrencyName", "ActualWeight", "WeightUnit", "PacketType", "PaymentType", "CODAmount", "CODCurrency","DescTotalValue", "Volumetric"];
        const requiredHeaders2 = ["CustReferenceNo", "Length", "Breadth", "Height"];
        const requiredHeaders3 = ["CustReferenceNo", "Description", "HsNo", "UniqueQuantity","unitValue", "Units"];

        if (!sheet1.length || !sheet2.length || !sheet3.length) {
            return false;
        }
        const dataHeaders1 = Object.keys(sheet1[0]);
        const dataHeaders2 = Object.keys(sheet2[0]);
        const dataHeaders3 = Object.keys(sheet3[0]);
        const sheet1Valid = requiredHeaders1.every(header => dataHeaders1.includes(header));
        const sheet2Valid = requiredHeaders2.every(header => dataHeaders2.includes(header));
        const sheet3Valid = requiredHeaders3.every(header => dataHeaders3.includes(header));
        return sheet1Valid && sheet2Valid && sheet3Valid;
    };

    const BulkSubmit = async (e) => {
        try {
            const data = await readFile2(e);
            console.log('Data from readFile:', data);
            setImportData({ sheet1: data.sheet1, sheet2: data.sheet2, sheet3: data.sheet3 });
            setName(data.FileName);
        } catch (error) {
            console.error('Error in BulkSubmit:', error);
            await NotificationSound('ERROR', 'Error processing file. Please try again.');
        }
    };

    //const handleBulk = async () => {
    //    const Data2 = {
    //        Type: PageType,
    //        "Token": CommonApiData().Token,
    //        "LoginUserCode": CommonApiData().LoginUserCode,
    //        "LoginBCode": CommonApiData().loginBCode,
    //        "Source": 'Web',
    //        "User": CommonApiData().UserName,
    //        "awbNo": '',
    //    };

    //    if ((ImportData && ImportData.sheet1.length !== 0) && (ImportData && ImportData.sheet2.length !== 0) && (ImportData && ImportData.sheet3.length !== 0)) {
    //        if (validateHeaders(ImportData.sheet1, ImportData.sheet2, ImportData.sheet3)) {
    //            const groupedData = groupDataByProductCode(ImportData.sheet1, ImportData.sheet2, ImportData.sheet3);
    //            console.log(ImportData.sheet2, "sheet2volumesdfsd")
    //            const Data = await HandleBulkInsertData('/api/Operation/InsertUpdatePickUpRequestMaster', groupedData, Data2, () => { setName('') });
    //            if (Data.status === 'EXPIRED') {
    //                await NotificationSound(Data.status, Data.message)
    //            } else {
    //                setStatus(Data);
    //                await NotificationSound('INFO', `Success: ${Data.SuccessCount} Error: ${Data.ErrorCount}`);
    //            }
    //        } else {
    //            await NotificationSound('ERROR', 'Header Format is not valid!');
    //            BulkClearData(setName);
    //        }
    //    } else {
    //        await NotificationSound('ERROR', 'Please Choose File With Valid Data!');
    //        BulkClearData(setName);
    //    }
    //};


    const handleBulk = async () => {
        const Data2 = {
            Type: PageType,
            "Token": CommonApiData().Token,
            "LoginUserCode": CommonApiData().LoginUserCode,
            "LoginBCode": CommonApiData().loginBCode,
            "Source": 'Web',
            "User": CommonApiData().UserName,
            "awbNo": '',
        };
        const divisor = 5000; // Divisor value as mentioned
        const calculateVolWeight = (length, width, height) => {
            if (!length || !width || !height) return '';
            return ((length * width * height) / divisor).toFixed(3);
        };
        if ((ImportData && ImportData.sheet1.length !== 0) && (ImportData && ImportData.sheet2.length !== 0) && (ImportData && ImportData.sheet3.length !== 0)) {
            if (validateHeaders(ImportData.sheet1, ImportData.sheet2, ImportData.sheet3)) {
                const groupedData = groupDataByProductCode(ImportData.sheet1, ImportData.sheet2, ImportData.sheet3);
                ImportData.sheet2.forEach(item => {
                    const volWeight = calculateVolWeight(Number(item.Length), Number(item.Breadth), Number(item.Height));
                    item.volWeight = volWeight;
                    
                });
                const Data = await HandleBulkInsertData('/api/Operation/InsertUpdatePickUpRequestMaster', groupedData, Data2, () => { setName('') });
                if (Data.status === 'EXPIRED') {
                    await NotificationSound(Data.status, Data.message);
                } else {
                    setStatus(Data);
                    await NotificationSound('INFO', `Success: ${Data.SuccessCount} Error: ${Data.ErrorCount}`);
                }
            } else {
                await NotificationSound('ERROR', 'Header Format is not valid!');
                BulkClearData(setName);
            }
        } else {
            await NotificationSound('ERROR', 'Please Choose File With Valid Data!');
            BulkClearData(setName);
        }
    };

    const groupDataByProductCode = (sheet1, sheet2, sheet3) => {
        const groupedData = {};

        sheet1.forEach(record => {
            if (!groupedData[record.awbNo]) {
                groupedData[record.awbNo] = {
                    ...record,
                    weightDetails: [],
                    descriptionDetail: [],

                };
            }
        });

        sheet2.forEach(detail => {
            if (groupedData[detail.awbNo]) {
                groupedData[detail.awbNo].weightDetails.push(detail);
            }
        });

        sheet3.forEach(detail => {
            if (groupedData[detail.awbNo]) {
                groupedData[detail.awbNo].descriptionDetail.push(detail);
            }
        });

        return Object.values(groupedData);
    };

    const DownloadFormat = async () => {
        await DownloadFileAtURL('PickUpRequest.xlsx');
    };

    //End Bulk Upload



    useEffect(() => {
        // inputrefs.current['txtCountryCode'].focus();
        document.title = 'Import PickUp Request'
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0">{menuText ? menuText : FindTranslatedKey('Import PickUp Request')}</h6>

                </div>
                <div className='card-body row'>

                    <div className='d-flex col-md-6 col-lg-4 h-25'>
                        <ImportButton
                            handleBulk={handleBulk}
                            BulkSubmit={(e) => BulkSubmit(e)}
                            downloadFormat={DownloadFormat}
                            ErrorData={ErrorData}
                            Status={Status}
                            HeaderFormat="PayMode, Active"
                            fileName={Name}
                        >
                        </ImportButton>
                    </div>

                </div>
            </div>


        </>
    )
}

export default ImportPickUpRequest;